import createSvgIcon from "./utils/create_icon"

const ErrorFill = createSvgIcon(<path clipRule="evenodd" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm-1 14a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm0-3a1 1 0 1 0 2 0V8a1 1 0 1 0-2 0z" fill="currentColor" fillRule="evenodd" />, "ErrorFill")
export default ErrorFill
